export default __webpack_public_path__ + "static/media/pokiGripperRover.5b04a3df.png";